/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    let video = $('#about-video')[0] || '';

    $('.btn-play').click((event) => {
        event.preventDefault();
        video.play();
        $('.btn-play').addClass('hidden');
    });

    if (video) {
        video.onended = (_) => {
            $('.btn-play').removeClass('hidden');
        };
    }
});
